var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34175",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10904 2.44861C8.92975 1.3907 11.1677 1.40919 12.9713 2.49705C14.7572 3.60706 15.8427 5.58812 15.8325 7.71917C15.791 9.83625 14.6271 11.8263 13.1722 13.3647C12.3325 14.2566 11.3932 15.0453 10.3734 15.7147C10.2684 15.7754 10.1533 15.8161 10.0339 15.8346C9.91902 15.8297 9.80711 15.7958 9.70831 15.7358C8.15137 14.7301 6.78546 13.4463 5.67629 11.9463C4.74817 10.6941 4.22088 9.18131 4.16602 7.61332C4.16481 5.47817 5.28832 3.50653 7.10904 2.44861ZM8.16115 8.49695C8.46742 9.252 9.19033 9.7445 9.99235 9.74451C10.5178 9.74828 11.0228 9.53782 11.395 9.16003C11.7672 8.78224 11.9756 8.2685 11.9737 7.73329C11.9765 6.91633 11.4956 6.17823 10.7554 5.86361C10.0152 5.549 9.16189 5.71993 8.59378 6.29659C8.02568 6.87326 7.85488 7.74191 8.16115 8.49695Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_743",
    opacity: 0.4,
    cx: 9.9987,
    cy: 17.5013,
    rx: 4.16667,
    ry: 0.833333,
    fill: "#EF4444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.194eda5b89489d3a71fa3c8e0490d969.svg";
export { ForwardRef as ReactComponent };